import {ONE_YEAR_MS} from '@/shared/consts/time';

import {CookieConsent} from '../types';

export function isCookieConsentExpired(
  consent: CookieConsent | null,
  now: number = Date.now()
): boolean {
  if (consent === null) {
    return true;
  }

  const {acceptAt} = consent;

  if (!Number.isFinite(acceptAt)) {
    return true;
  }

  return now - acceptAt >= ONE_YEAR_MS;
}
